<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="m12.648 2.4 2.975 5.891 5.725.567a.724.724 0 0 1 .61.474.713.713 0 0 1-.17.748l-4.715 4.67 1.747 6.344a.713.713 0 0 1-.24.744.73.73 0 0 1-.783.086L12 19.054l-5.797 2.87a.73.73 0 0 1-.782-.087.713.713 0 0 1-.24-.743L6.93 14.75l-4.716-4.67a.713.713 0 0 1-.171-.75.724.724 0 0 1 .611-.473l5.724-.568 2.972-5.89A.725.725 0 0 1 12 2c.275 0 .527.155.649.4Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
